module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/decorations/deco-blob-11-01c2a9439dc8dff9df6d9aa64fd3710e.svg";